"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.object.to-string.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _react = require("react");

var _client = require("@apollo/client");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _locales = require("@meepshop/locales");

var _link = require("@meepshop/link");

// typescript import
// import
// definition
var _default = function _default(initialCookies, getCookies) {
  var router = (0, _link.useRouter)();
  var client = (0, _client.useApolloClient)();

  var _useTranslation = (0, _locales.useTranslation)(),
      i18n = _useTranslation.i18n;

  var _useState = (0, _react.useState)(initialCookies),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      cookies = _useState2[0],
      setCookies = _useState2[1];

  (0, _react.useEffect)(function () {
    var offResetStore = client.onResetStore( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setCookies({});
              _context.t0 = setCookies;
              _context.next = 4;
              return getCookies({
                pathname: router.pathname,
                query: router.query,
                client: client,
                i18n: i18n,
                language: i18n.language,
                cookie: _jsCookie["default"]
              });

            case 4:
              _context.t1 = _context.sent;
              (0, _context.t0)(_context.t1);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    return function () {
      offResetStore();
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.pathname]);
  (0, _react.useEffect)(function () {
    setCookies(initialCookies); // 從 browser 設定 identity

    if (!_jsCookie["default"].get('identity')) {
      _jsCookie["default"].set('identity', (0, _v["default"])(), {
        expires: new Date((Math.pow(2, 31) - 1) * 1000)
      });
    }

    if (router.query.promoCode) {
      _jsCookie["default"].set('promoCode', router.query.promoCode, {
        path: '/',
        maxAge: (60 * 60 * 24 * 365 * 10).toString()
      });
    }
  }, [initialCookies, router.query]);
  return {
    cookies: cookies,
    setCookie: (0, _react.useCallback)(function (key, value) {
      if (typeof window === 'undefined') return;

      _jsCookie["default"].set(key, value);
    }, [])
  };
};

exports["default"] = _default;